'use strict';

const providerFlags = {
  canvas: 'canvas_user',
  classlink: 'classLink_user',
  clever: 'clever_user',
  google: 'google_user',
  schoology: 'schoology_user'
};

function normalizeLoginProvider(loggedBy) {
  return String(loggedBy || '').trim().toLowerCase();
}

function getLoginImportProvider(user) {
  const provider = normalizeLoginProvider(user && user.loggedBy);
  const providerFlag = providerFlags[provider];

  if (!providerFlag || !user || !user[providerFlag]) {
    return null;
  }
  return provider;
}

function isLoginImportProvider(user, provider) {
  return getLoginImportProvider(user) === provider;
}

function isLoginImportAvailable(user, provider, integrationFetched) {
  const normalizedProvider = normalizeLoginProvider(provider);
  return normalizeLoginProvider(integrationFetched) === normalizedProvider &&
    isLoginImportProvider(user, normalizedProvider);
}

module.exports = {
  getLoginImportProvider,
  isLoginImportAvailable,
  isLoginImportProvider,
  normalizeLoginProvider
};
